// src/utils/notification.js
import { getToken } from 'firebase/messaging';
import { messaging } from '../firebase';
import axiosInstance from './axiosInstance';
 

export const generateFcmToken = async () => {
  try {
    // Explicitly register firebase-messaging-sw.js
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    // Get the token using the correct service worker
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VapidKey, // from Firebase console
      serviceWorkerRegistration: registration,  // ✅ Important
    });

    return token;
  } catch (error) {
    console.error('Error generating FCM token:', error);
    return null;
  }
};



export const requestFirebaseNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      const token = await generateFcmToken()
      console.log('FCM Token:', token);
      return token;
    } else {
      console.warn('Notification permission not granted');
      return null;
    }
  } catch (err) {
    console.error('Error getting notification permission or token:', err);
    return null;
  }
};



export const readMessages = async (payload) => {
  try {

    await axiosInstance.post(`/delete_notifaction/`, payload);
    return true;
  } catch (error) {
    console.log(error)
  }
}